<template>
  <app-tab :label="$t('header.tipsTab.modalTabTitle')" id="notification-dialog-tips" class="user-notifications-tab-tips">
    <div class="user-notification-video">
      <iframe frameborder="0" allowfullscreen :src="activeTip.url"></iframe>
    </div>

    <user-notifications-list>
      <user-notifications-list-item
        v-for="({ title, duration }, index) in tips"
        :class="{ selected: index === selectedTip }"
        :key="index"
        icon="play"
        :title="title"
        :date="duration"
        tabindex="0"
        @click.native="setActiveTip(index)"
        @keyup.enter="setActiveTip(index)"
        @keyup.space="setActiveTip(index)"
      />
    </user-notifications-list>
  </app-tab>
</template>

<script>
  import { mapState } from 'vuex'
  import UserNotificationsList from './UserNotificationsList'
  import UserNotificationsListItem from './UserNotificationsListItem'

  export default {
    name: 'UserNotificationsDialogTabTips',
    components: {
      UserNotificationsList,
      UserNotificationsListItem
    },
    props: {
      type: {
        type: String
      },
      itemId: {
        type: [Number, String],
        default: 0
      }
    },
    data: () => ({
      activeTip: null,
      selectedTip: null
    }),
    computed: {
      ...mapState('userNotifications', ['tips'])
    },
    methods: {
      setActiveTip (index) {
        this.activeTip = this.tips[index]
        this.selectedTip = index
      }
    },
    created () {
      this.setActiveTip(this.type === 'tips' && this.itemId ? this.itemId : 0)
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta';

  .user-notifications-tab-tips {
    display: flex;

    ::v-deep {
      .list-item-icon {
        background-color: $color-silver;
        border-radius: 6px;

        svg {
          width: 22px;
          height: 22px;
          fill: #fff;
        }
      }
    }
  }

  .user-notification-video {
    min-width: 680px;
    padding: 18px 20px;

    iframe {
      width: 100%;
      height: 350px;
    }
  }

  .selected {
    background-color: #f9f9f9;

    ::v-deep .list-item-icon {
      background-color: $color-blue;
      border-radius: 6px;
    }
  }
</style>
